import React from 'react';
import PropTypes from 'prop-types';
import MLIcon from '../../MLIcon/MLIcon';

import s from './CategoryOrder.module.css';

const INITIAL_ORDER_VALUE = 0;

const CategoryOrder = ({
  categoryName,
  order,
  disableNext,
  onUpdateCategoryOrder,
  disableComponent,
}) => {
  if (order === null || order === undefined) return null;

  return (
    <div className={s.container}>
      <div className={s.label}>Display</div>
      <div className={s.controlsContainer}>
        <div className={s.buttonsContainer}>
          <button
            tabIndex={0}
            disabled={order === INITIAL_ORDER_VALUE || disableComponent}
            onClick={() => onUpdateCategoryOrder(-1)}
            aria-label={`${categoryName} up`}
          >
            <MLIcon
              type="category_order_chevron_up"
              viewBox="0 0 12 8"
              width={12}
              height={8}
            />
          </button>

          <button
            tabIndex={0}
            disabled={disableNext || disableComponent}
            onClick={() => onUpdateCategoryOrder(1)}
            aria-label={`${categoryName} down`}
          >
            <MLIcon
              type="category_order_chevron_down"
              viewBox="0 0 12 8"
              width={12}
              height={8}
            />
          </button>
        </div>
        <div className={s.value}>{order + 1}</div>
      </div>
    </div>
  );
};

CategoryOrder.propTypes = {
  order: PropTypes.number.isRequired,
  disableNext: PropTypes.bool,
  onUpdateCategoryOrder: PropTypes.func,
  categoryName: PropTypes.string,
  disableComponent: PropTypes.bool,
};

CategoryOrder.defaultProps = {
  disableNext: false,
};

export default CategoryOrder;
